<template>
  <el-card class="h-full relative">
    <div class="w-full h-full" v-if="!isSHowPaper">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="考试名称"
          maxlength="50"
          v-model="searchData.keywords"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.examCategory"
          size="small"
          class="mr-10px !w-50 mb-10px mb-10px"
          placeholder="请选择考试类型"
          clearable
        >
          <el-option
            v-for="item in pagerTypeList"
            :key="item.value"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="searchData.startTime"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('开始日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-date-picker
          v-model="searchData.endTime"
          type="date"
          size="small"
          class="mr-10px !w-50"
          :placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select
          v-model="searchData.makeUpExam"
          size="small"
          class="mr-10px !w-50"
          placeholder="是否补考"
          clearable
        >
          <el-option
            v-for="item in passList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button size="small" type="primary" @click="sizeChange()">搜索</el-button>
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="试卷名称" prop="examName" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.examName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="考试类型"
          prop="examCategoryText"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否补考" prop="makeUpExam" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            {{ scope.row.makeUpExam ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="考试时间" prop="coursewareTimes" width="300" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row | showText('time') }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="考试时长（min）"
          prop="answerTime"
          width="140"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column label="是否通过" width="100" prop="pass" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.pass ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="得分" prop="customerScore" show-overflow-tooltip width="100">
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="viewInfo(scope.row)"
              :disabled="!scope.row.markingPaper || scope.row.examStatus !== 2"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="searchList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :page-size.sync="page.pageSize"
        :total="page.pageTotal"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <div v-if="isSHowPaper" class="h-full">
      <el-page-header @back="isSHowPaper = false" content="试卷"></el-page-header>
      <div class="w-1000px m-auto" style="height:calc( 100% - 30px );border: dashed 1px #999">
        <PaperCom :renderData.sync="renderData" :originData="originData" />
      </div>
    </div>
  </el-card>
</template>

<script>
import { TaskExamAnswerRecordApi, TextContentApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import PaperCom from '../../components/examManage/PaperCom'

const taskExamAnswerRecordApi = new TaskExamAnswerRecordApi()
const textContentApi = new TextContentApi()

export default {
  name: 'examine-paper-study',
  components: { PaperCom },
  props: ['userId'],
  data() {
    return {
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      searchData: {
        startTime: null,
        keywords: '',
        endTime: '',
        examCategory: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      passList: [
        { label: '是', value: true },
        { label: '否', value: false },
      ],
      originData: {},
      renderData: [],
      isSHowPaper: false,
      pagerTypeList: [],
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        if (val.examStartTime && val.examEndTime) {
          result = `${dayjs(val.examStartTime).format('YYYY-MM-DD HH:mm')} - ${dayjs(
            val.examEndTime
          ).format('YYYY-MM-DD HH:mm')}`
        } else if (val.examStartTime) {
          result = `${dayjs(val.examStartTime).format('YYYY-MM-DD HH:mm')} - 无`
        }
      }
      return result
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    expandHandle(row, isOpen) {
      if (isOpen) {
        if (Object.keys(this.currentOpen).length) {
          this.$refs.tableRef.toggleRowExpansion(this.currentOpen, false)
        }
        this.currentOpen = row
      } else {
        this.currentOpen = {}
      }
    },
    // 导出
    async exportData(data) {
      this.exportLoading = true
      const [err, res] = await taskExamAnswerRecordApi.taskExamAnswerRecordExportToExcelFile({
        examPlanId: data.planId,
      })
      this.exportLoading = false
      if (err) return
      if (!err) {
        this.downLoadExcel('考试记录.xlsx', res, 'excel')
        this.$message({
          showClose: true,
          message: '下载成功',
          type: 'success',
        })
      }
    },
    // 文件流下载
    downLoadExcel(fileName = '下载文件', data, type) {
      const fileType = {
        zip: 'application/zip',
        excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }
      const blob = new Blob([data], {
        type: fileType[type],
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 重考
    goAnew(data) {
      this.operateData = data
      this.anewVis = true
    },
    // 查看
    async viewInfo(row) {
      // console.log(row)
      const [err, res] = await textContentApi.get(row.markingPaperTextContentId)
      if (err) return
      function cloneObj(data, middleObj) {
        Object.keys(data).forEach((key) => {
          const midKey = key.slice(0, 1).toLowerCase() + key.slice(1)
          middleObj[midKey] = data[key]
          if (typeof data[key] === 'object' && data[key]) {
            middleObj[midKey] = Array.isArray(data[key]) ? [] : {}
            cloneObj(data[key], middleObj[midKey])
          }
        })
      }
      const content = {}
      JSON.parse(res.content)
      cloneObj(JSON.parse(res.content), content)
      res.content = content
      const examEndTime = res.content.examEndTime
      const examStartTime = res.content.examStartTime
      res.content.examStartTime =
        examStartTime && dayjs(examStartTime).format('YYYY-MM-DD HH:mm:ss')
      res.content.examEndTime = examEndTime && dayjs(examEndTime).format('YYYY-MM-DD HH:mm:ss')
      this.originData = res
      this.renderData = res.content.topicTypes.filter((item) => {
        return item.topicContents.length
      })
      this.renderData = this.renderData.map((item) => {
        if (item.questionType !== 1) {
          return item
        }
        item.topicContents = item.topicContents.map((topic) => {
          if (topic.examineeAnswerContent) {
            // 处理历史数据
            topic.examineeAnswerContent = topic.examineeAnswerContent
              .split(',')
              .sort()
              .join(',')
          }
          return topic
        })
        return item
      })
      this.updateScore()
      this.isSHowPaper = true
    },
    // 更新分数
    updateScore() {
      this.originData.content.paperTotalScore = 0
      this.totalScore = 0
      this.renderData.forEach((item) => {
        item.score = 0
        item.topicContents.forEach((val) => {
          item.score += val.examineeScore
        })
        this.originData.content.paperTotalScore += item.score
      })
    },
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.sizeChange()
    },
    /**
     * @description 分页数改变
     */
    sizeChange() {
      this.page.pageNo = 1
      this.searchList()
    },
    // 列表
    async searchList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        userId: this.userId,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        ...searchData,
      }
      // if (data.startTime) {
      //   data.startTime = dayjs(data.startTime).format('YYYY-MM-DD HH:mm:ss')
      // }
      // if (data.endTime) {
      //   data.endTime = dayjs(data.endTime).format('YYYY-MM-DD 23:59:59')
      // }
      this.equipTableLoading = true
      const [err, res] = await taskExamAnswerRecordApi.examineePageList(data)
      this.equipTableLoading = false
      if (!err) {
        this.equipDataList = res.items
        this.page.pageTotal = res.totalCount
      }
    },
  },
  mounted() {
    utils.getDataCategory(['ExamManagement.DataCategory.ExamType'], ['pagerTypeList'], this)
    this.searchList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
